import { isDefinedIncludingZero } from 'app/infrastructure/data/number';
import { ValidationParameter, ValidationRoot } from './types';
import { MessagesValidation } from './types-store';

export const clearValidationForSingleParameter = (
  validation: MessagesValidation,
  root: ValidationRoot,
  parameter: ValidationParameter,
  id: number
): MessagesValidation =>
  validation && validation[root] && validation[root].messages
    ? {
      ...validation,
      [root]: {
        ...validation[root],
        messages: validation[root].messages.filter(
          m => !m || !m.parameters || !isDefinedIncludingZero(m.parameters[parameter]) || m.parameters[parameter] !== id)
      }
    }
    : validation;

export const clearValidationForAllParameter = (
  validation: MessagesValidation,
  parameter: ValidationParameter
): MessagesValidation =>
  validation && validation.translations && validation.translations.messages
    ? {
      ...validation,
      translations: {
        ...validation.translations,
        messages: validation.translations.messages.filter(
          m => !m || !m.parameters || !isDefinedIncludingZero(m.parameters[parameter]))
      }
    }
    : validation;
